export default "__VITE_ASSET__bb147a90__"